<template>
    <div>
        <img ref="image" height="75" :src="imageSrc" alt="your image"/>
        <input type="file" id="imageInput" @input="changeFile"
               :placeholder="placeholder">
    </div>
</template>


<script>
export default {
    name: "ImageInput",
    props: {
        value: '',
        placeholder: '',
        required: ''
    },
    data() {
        return {
            imageSrc: this.value,
        }
    },
    methods: {
        renderImage() {
            var reader = new FileReader();
            reader.readAsDataURL(this.imageSrc)
            reader.onload = (e) => {
                $(this.$refs.image)
                    .attr('src', e.target.result)
                    .width(150)
                    .height(200);
            };
        },
        changeFile(event){
            this.imageSrc = event.target.files[0]
        }
    },
    watch: {
        imageSrc: {
            handler: function (data) {
                this.$emit('input', data)
                this.renderImage()
            },
            deep: true,
            immediate: true        }
    }
}
</script>